import React from 'react';
import companyInfo from '../../../themes/themes';
import { useMobile } from 'frontend/src/hooks/useMobile';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as CheckMarkIcon } from '../../../images/checkmarkblack.svg';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& .MuiListItemIcon-root': {
      minWidth: 45,
    },
    '& .MuiListItem-root': { paddingTop: 0 },
    '& .MuiListItemText-root': {
      flex: 'none',
    },
  },
  rootMobile: {
    display: 'flex',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& .MuiListItemIcon-root': {
      minWidth: 45,
    },
    '& .MuiListItem-root': { paddingTop: 0 },
  },
  list: { maxWidth: 400 },
  listItem: {
    marginTop: 0,
    marginBottom: 0,
    display: 'flex',
  },
  text: { fontSize: '1.5em' },
  icon: { fontSize: theme.spacing(3.5), color: theme.palette.status.active },
}));

export default function TermCheckList() {
  const mobile = useMobile('sm');
  const classes = useStyles();

  const theme = process.env.REACT_APP_THEME;

  const highlights = [
    'No credit check',
    'No personal guarantees',
    'Your data is 100% secure',
    `${companyInfo[theme]?.company} will never move funds without your consent`,
    'Unlink at any time',
  ];

  return (
    <div className={mobile ? classes.rootMobile : classes.root}>
      <List className={classes.list}>
        {highlights.map((highlight, i) => (
          <ListItem key={i} className={classes.listItem} alignItems="center">
            <ListItemIcon>
              <CheckMarkIcon className={classes.icon} />
            </ListItemIcon>
            <ListItemText primary={highlight} className={classes.text} />
          </ListItem>
        ))}
      </List>
    </div>
  );
}
